<template>
  <div class="buyorder">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item" class="orderitem" :title="item">
          <div class="order_title">{{ item.created_at }}</div>
          <div class=" order-item-mian zs-p-col-20">
            <div>
              <span>应付金额</span>
              <span>￥{{ item.payment_price | sumPrice( item.preferential_amount) }}</span>
            </div>
            <div>
              <span>优惠金额</span>
              <span>￥{{ item.preferential_amount }}</span>
            </div>
          </div>
          <div class=" order-foot">
            <span>实际支付金额:</span>
            <span class="foot-right">￥{{ item.payment_price }}</span>
          </div>
        </div></van-list>
    </van-pull-refresh>

  </div>
</template>

<script>
import {
  arrivalOrderList

} from '@/api/goods'
export default {
  filters: {
    sumPrice(value, payment) {
      if (payment) {
        return Number(value) + Number(payment)
      } else {
        return Number(value)
      }
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: true,
      opstdata: {
        number: 10,
        page: 1
      }
    }
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
          this.opstdata.page = 1
        }

        arrivalOrderList(this.opstdata).then(res => {
          if (res.code == 200) {
            // this.list = res.data.data
            this.list = [... this.list, ...res.data.data]
            this.loading = false

            if (this.list.length >= res.data.total) {
              this.finished = true
            } else {
              this.opstdata.page++
            }
          }
        })

        // for (let i = 0; i < 10; i++) {
        //   this.list.push(this.list.length + 1)
        // }
        // this.loading = false

        // if (this.list.length >= 40) {
        //   this.finished = true
        // }
      }, 1000)
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  }
}
</script>

<style lang="scss" scoped>
.buyorder{
  padding: 20px;
  box-sizing: border-box;
}
.orderitem{
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;

  padding: 20px;

  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .order_title{
  font-weight: bold;
    font-size: 32px;

  }
  .order-item-mian{
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgb(233, 227, 227);
    >div{
      flex: 1;
      text-align: center;
        display: flex;
  flex-direction: column;
    }

  }
  .order-foot{
    display: flex;
    padding-top: 20px;
    justify-content: space-between;
    font-size: 32px;
    .foot-right{
  font-weight: bold;
  color: #F23926;
    }

  }
}

</style>>
